import CryptoTool from './CryptoTool'

function addFormData(key, value) {
    if (!localStorage.getItem('form-data')) {
        localStorage.setItem('form-data', "{}")
    }
    let data = JSON.parse(localStorage.getItem('form-data'))
    data[key] = CryptoTool.encrypt(JSON.stringify(value))
    localStorage.setItem('form-data', JSON.stringify(data))
}

function removeFormData(key) {
    if (localStorage.getItem('form-data')) {
        let data = JSON.parse(localStorage.getItem('form-data'))
        delete data[key]
        localStorage.setItem('form-data', JSON.stringify(data))
    }
}

function getFormData(key) {
    if (localStorage.getItem('form-data')) {
        let data = JSON.parse(localStorage.getItem('form-data'))
        if (data[key]) {
            return JSON.parse(CryptoTool.decrypt(data[key]))
        }
        return null
    }
}

function blockData(key) {
    let cards = require('@/processes/conf/default.js').default
    let companyTool = require('@/tools/CompanyTool').default
    if (companyTool.keyname) {
        let overrideCards = companyTool.processConf().process
        for (var cardIndex in overrideCards) {
            cards[overrideCards[cardIndex].key] = overrideCards[cardIndex]
        }
    }

    return cards[key]
}

var FormTool = {
    addFormData,
    removeFormData,
    getFormData,
    blockData
}

export default FormTool



// WEBPACK FOOTER //
// ./src/tools/FormTool.js